module.exports = __webpack_public_path__ + "static/media/uhoh.989edcb0.png";